export default __webpack_public_path__ + "static/media/Photo 6 - BR - Plan 1.5c5e2ae4.png";